import { ERROR_NAME } from "./constants"
import type { FetchError } from "./FetchError"

export const isFetchError = (error: unknown): error is FetchError => {
  return error instanceof Error && error.name === ERROR_NAME
}
